/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

angular.module('aviApp').directive('headerCollapseButton', function() {
    return {
        scope: {
            expanded: '=',
        },
        link(scope, element) {
            element.addClass('header-collapse-button');
            scope.$watch(function() {
                return scope.expanded;
            }, function(newValue) {
                if (newValue) {
                    element.addClass('expanded');
                } else {
                    element.removeClass('expanded');
                }
            });
        },
        restrict: 'AE',
        template: '<i class = "icon icon-minus"></i><i class = "icon icon-plus"></i>',
    };
});
